import { useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { Spacer } from '../../components/Spacer';
import { Typography } from '../../components/Typography';

/**
 * Modal when only two minutes left, and extends timed out for extra three minutes.
 * Tries to continue their booking with a fresh table matching the time, if possible
 */
const TimedOutExtender = ({ open, onClose, onConfirm, onReset, timeRemaining }) => {
  // Convert timeRemaining from milliseconds to minutes and seconds
  const minutes = Math.floor(timeRemaining / (1000 * 60));
  const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

  const theme = useTheme();

  useEffect(() => {
    if (open && timeRemaining === 0) {
      window.location.reload();
      onReset();
      onClose();
    }
  }, [open, timeRemaining]);

  const handleClose = (_, reason) => {
    // Prevent closing the dialog when clicking the backdrop
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <Modal
      showHeader
      title='Your session is about to expire'
      open={open}
      onClose={handleClose}
      closeButtonStyle={{
        color: theme.colors.smoke,
      }}
    >
      <Spacer direction='vertical' gap={24} style={{ paddingTop: '20px' }}>
        <Typography style={{ minWidth: '450px' }}>
          You have {minutes > 0 ? `${minutes} min ` : ''}
          {seconds > 0 ? `${seconds} sec` : ''} left to complete this booking.
        </Typography>
        <Typography>Click the button below to extend session by 3 minutes.</Typography>
        <Spacer style={{ alignItems: 'flex-end', paddingTop: '20px' }}>
          <Button
            variant='outlined'
            size='small'
            onClick={onConfirm}
            // disabled={loading}
            style={{
              borderRadius: `${theme.colors.availabilityMainButtonCornerRadius || 2}px`,
              color: theme.colors.availabilityMainButtonTextColour,
              border: `1px solid ${theme.colors.availabilityMainButtonBgColour}`,
              backgroundColor: theme.colors.availabilityMainButtonBgColour,
            }}
          >
            Extend session
          </Button>
        </Spacer>
      </Spacer>
    </Modal>
  );
};

TimedOutExtender.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  timeRemaining: PropTypes.number.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TimedOutExtender);
